import React from 'react';

interface EmailWizardStep2Props {
    subject: string;
    setSubject: (subject: string) => void;
    cc: string;
    setCc: (cc: string) => void;
    content: string;
    setContent: (content: string) => void;
    attachInvoice: boolean;
    setAttachInvoice: (attach: boolean) => void;
    insertPlaceholder: (placeholder: string) => void;
}

const EmailWizardStep2: React.FC<EmailWizardStep2Props> = ({
    subject,
    setSubject,
    cc,
    setCc,
    content,
    setContent,
    attachInvoice,
    setAttachInvoice,
    insertPlaceholder,
}) => {
    const placeholders = [
        { label: 'Name', value: '{{name}}' },
        { label: 'Tischnummer', value: '{{tableNumber}}' },
        { label: 'Mitgliederanzahl', value: '{{memberCount}}' },
        { label: 'Bankkonto', value: '{{bankAccount}}' },
    ];

    return (
        <div className="wizard-step">
            <h3>E-Mail Inhalt</h3>
            <p style={{ color: '#6c757d', marginBottom: '16px' }}>
                Formulieren Sie die E-Mail, die an die ausgewählten Round Tables gesendet wird.
            </p>

            <div className="form-group">
                <label htmlFor="email-subject">
                    Betreff <span className="required">*</span>
                </label>
                <input
                    id="email-subject"
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Betreff der E-Mail"
                />
            </div>

            <div className="form-group">
                <label htmlFor="email-cc">CC (optional)</label>
                <input
                    id="email-cc"
                    type="email"
                    value={cc}
                    onChange={(e) => setCc(e.target.value)}
                    placeholder="CC-Empfänger (z.B. example@domain.com)"
                />
            </div>

            <div className="form-group">
                <label htmlFor="email-content">
                    Inhalt <span className="required">*</span>
                </label>
                <textarea
                    id="email-content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    placeholder="E-Mail Inhalt..."
                    rows={8}
                    style={{
                        width: '100%',
                        padding: '12px 14px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        fontSize: '16px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                    }}
                />
            </div>

            {/* Placeholder Tags */}
            <div className="placeholder-tags">
                <label style={{ fontWeight: 600, color: '#333', fontSize: '14px', marginBottom: '8px', display: 'block' }}>
                    Platzhalter einfügen:
                </label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {placeholders.map(ph => (
                        <button
                            key={ph.value}
                            type="button"
                            className="placeholder-tag-btn"
                            onClick={() => insertPlaceholder(ph.value)}
                        >
                            {ph.label}
                        </button>
                    ))}
                </div>
                <p style={{ fontSize: '13px', color: '#6c757d', marginTop: '8px' }}>
                    Diese Platzhalter werden für jeden Empfänger durch die entsprechenden Werte ersetzt.
                </p>
            </div>

            <div className="form-group" style={{ marginTop: '20px' }}>
                <label className="checkbox-label" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <input
                        type="checkbox"
                        checked={attachInvoice}
                        onChange={(e) => setAttachInvoice(e.target.checked)}
                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                    />
                    <span style={{ fontWeight: 600, color: '#333' }}>Rechnung als PDF anhängen</span>
                </label>
            </div>
        </div>
    );
};

export default EmailWizardStep2;
